import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

const CountryCode = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const {form_component} = props;
	const [countryCodes, setCountryCodes] = useState([]);
	
	const fv = useSelector(state => state.fv);

	const pageData = useSelector(state => state.pageData);
	const {acct_id, controller} = pageData;

	const contactFields = useSelector(state => state.contactFields);
	const {country_code} = contactFields;

	const userData = useSelector(state => state.userData);

	useEffect(() => { // to be updated after render
		// 確保優先等候 Turnstile token，就算沒有也在短暫延遲後退回載入
		let didLoad = false;
		const tryLoad = () => {
			if (didLoad) return;
			didLoad = true;
			loadData();
		};

		// 已有 token 直接載入
		if (window.turnstileToken) {
			tryLoad();
		} else {
			// 監聽 token 就緒事件
			const onReady = () => tryLoad();
			document.addEventListener('turnstileReady', onReady, { once: true });
			// 最多等 2 秒，避免阻塞（即使沒有 token 也先載入）
			setTimeout(tryLoad, 2000);
			return () => {
				document.removeEventListener('turnstileReady', onReady);
			};
		}
	}, []);

	const registerField = () => {
		// For Shopcarts controller, only use global validator
		// For other controllers, use Redux store validator
		const validator = controller === 'Shopcarts' ? window.globalFormValidator : fv;
		
		if (validator && form_component.required) {
			const fieldName = controller === 'Shopcarts' ? 'buyer_country_code' : 'country_code';
			
			try {
				// Check if field already exists and remove it first
				if (validator.elements && validator.elements[fieldName]) {
					validator.removeField(fieldName);
				}
				
				validator.addField(fieldName, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					},
					// Explicitly specify the element selector
					selector: `select[name="${fieldName}"]`
				});
			} catch (error) {
				console.error('Error registering field:', fieldName, error);
			}
		}
	};

	useEffect(() => { // to be updated after render
		registerField();
	}, [fv, controller, form_component.required, t]);

	// Listen for FormValidation reinitialization
	useEffect(() => {
		const handleReinitialization = (event) => {
			registerField();
		};

		document.addEventListener('formValidationReinitialized', handleReinitialization);
		
		return () => {
			document.removeEventListener('formValidationReinitialized', handleReinitialization);
		};
	}, [fv, controller, form_component.required, t]);

	async function loadData() {
		try {
			let country_codes = [], default_country_code = '';

			const response = await axios.get(`/Countries/ajaxGetData/${acct_id}`);

			country_codes = response.data.country_codes;
			default_country_code = response.data.default_country_code;
			
			if (form_component?.country_code_display_option === 'specific') {
				country_codes = form_component?.country_code_options;
			}

			setCountryCodes(country_codes);
			
			const payload = {
				field: 'country_code',
				value: default_country_code
			}

			//console.log('userData', userData);

			if (!userData || typeof userData.country_code === 'undefined') {
				//console.log('userData is empty, setting default country code');
				dispatch({type: 'SET_CONTACT_FIELD', payload: payload});
			}
		} catch (e) {
			console.error(e);
		}
	}

	const onChange = (e) => {
		const value = e.target.value;

		const payload = {
			field: 'country_code',
			value: value
		}

		dispatch({type: 'SET_CONTACT_FIELD', payload: payload});
	}

	return (
		<select
			name={controller === 'Shopcarts' ? 'buyer_country_code' : 'country_code'}
			className="mw-100px form-select"
			id={controller === 'Shopcarts' ? 'buyer-country-code' : 'country-code'}
			value={country_code}
			onChange={onChange}
		>
			{(() => {
				const components = [];
				
				countryCodes.map((countryCode, index) => {
					components.push(
						<option key={`country-code-${index}`} value={countryCode}>{countryCode}</option>
					);
				})

				return components;
			})()}
		</select>
	);

}

export default CountryCode;